import React, {useEffect, useState} from 'react';
import {Button, Col, Popover, Row, Tooltip} from 'antd';
import { FormattedMessage as IntlMessages } from 'react-intl';
import { Link } from 'react-router-dom';
import TopbarDropdownWrapper from './TopbarDropdown.styles';
import {getUserNotifications, markAsRead} from "../../../services/notifications/notifications.service";
import * as N from "./styles";
import parse from 'html-react-parser';
import { notification } from 'antd';
import { stripAnchorsIfVisualOnly } from '@services/notifications/messageUtils';

export default function TopbarNotification() {
  const [visible, setVisiblity] = React.useState(false);
  const [notifications, setNotifications] = useState([]);

  const iconStatus = (notification) => {
    switch (notification.type) {
      case 'cash_conciliation_approved':
      case 'inventory_approved':
        return <N.CheckIcon/>;
      case 'cash_conciliation_refused':
      case 'inventory_rejected':
        return <N.DisapprovedIcon/>;
      default:
        return null;
    }
  };
  useEffect(() => {
    getNotifications()
  }, []);

  const getNotifications = async () => {
  try {
    const response = await getUserNotifications();

    const filteredNotifications = response?.data?.data?.filter(
      notification => notification.type !== 'cash_conciliation_reject_solicitation'
    ) || [];

    setNotifications(filteredNotifications);
  } catch (error) {
    console.error('Erro ao buscar notificações:', error);
    notification.error({
      message: 'Erro ao carregar notificações',
      description: error?.response?.data?.message || 'Ocorreu um erro inesperado. Tente novamente mais tarde.',
    });
  }
};

  const handleClickNotification = async (notification) => {
    await markAsRead(notification.id);
    getNotifications();
  }

  function handleVisibleChange() {
    setVisiblity((visible) => !visible);
  }

  const content = (
    <TopbarDropdownWrapper className="topbarNotification">
      <div className="isoDropdownHeader">
        <h3>
          <IntlMessages id='Notificações'/>
        </h3>
      </div>
      <div className="isoDropdownBody">
        {notifications.length === 0 ? (
          <N.CenterDiv>
            <h5>Nada por aqui.</h5>
          </N.CenterDiv>
        ) : (
          notifications.map((notification) => (
              <a className="isoDropdownListItem" href="#!" key={notification.id}>
                <Row>
                  <Col span={3}>
                    {iconStatus(notification)}
                  </Col>
                  <Col span={19}>
                    <h5>{parse(stripAnchorsIfVisualOnly(notification.type, notification.message))}</h5>
                  </Col>
                  <Col span={2}>
                    <Tooltip title='Excluir notificação'>
                      <Button type='link' onClick={() => handleClickNotification(notification)}>
                        <N.XIcon/>
                      </Button>
                    </Tooltip>
                  </Col>
                </Row>
              </a>
            )
          )
        )}
      </div>
      <div style={{ padding: '10px 16px', borderTop: '1px solid #eef2f7', textAlign: 'center' }}>
        <Link
          to="/notificacoes"
          onClick={() => setVisiblity(false)}
          style={{ color: '#2563eb', fontWeight: 600, fontSize: 13, textDecoration: 'none' }}
        >
          Ver todas as notificações
        </Link>
      </div>
    </TopbarDropdownWrapper>
  );
  return (
    <Popover
      content={content}
      trigger="click"
      open={visible}
      onOpenChange={handleVisibleChange}
      placement="bottomLeft"
    >
      <div className="isoIconWrapper">
        <i
          className="ion-android-notifications"
          style={{color: '#b0b5be'}}
        />
        <span>{notifications.length}</span>
      </div>
    </Popover>
  );
}
